import React, { useState } from "react";
import { AdminApis } from "../../apis/adminApi";
import { useParams } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { FiExternalLink } from "react-icons/fi";

export default function CardViewMultiPage() {
  const params = useParams();
  const [multiLinks, setMultiLinks] = useState(null);
  const [attachLinks, setAttachLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  React.useEffect(() => {
    AdminApis.getMultiLinkData(params?.linkId)
      .then((res) => {
        if (res?.data?.data) {
          setMultiLinks(res.data.data.multiLinks);
          setAttachLinks(res.data.data.attachLinks || []);
        } else {
          setNotFound(true);
        }
      })
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#fafaf9]">
        <div className="w-8 h-8 rounded-full border-2 border-gray-200 border-t-gray-500 animate-spin" />
      </div>
    );
  }

  if (notFound || !multiLinks) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#fafaf9] px-4">
        <div className="text-center">
          <p className="text-gray-400 text-sm mb-1">This page doesn't exist.</p>
          <p className="text-xs text-gray-300">Powered by Gupta</p>
        </div>
      </div>
    );
  }

  const businessSite = multiLinks?.business_website;

  return (
    <div className="min-h-screen bg-[#fafaf9] flex flex-col items-center justify-start py-16 px-4">
      <div className="w-full max-w-[360px]">

        {/* Logo */}
        <div className="flex justify-center mb-6">
          <div className="w-24 h-24 rounded-full overflow-hidden ring-4 ring-white shadow-lg bg-gray-100">
            {multiLinks?.logo ? (
              <img src={multiLinks.logo} alt="logo" className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-gray-100">
                <FaWhatsapp className="text-gray-300" size={32} />
              </div>
            )}
          </div>
        </div>

        {/* Title + bio */}
        <div className="text-center mb-8">
          <h1 className="text-xl font-bold text-gray-900 tracking-tight">{multiLinks?.title}</h1>
          {multiLinks?.bio && (
            <p className="text-sm text-gray-400 mt-1.5 leading-relaxed">{multiLinks.bio}</p>
          )}
        </div>

        {/* WhatsApp links */}
        <div className="space-y-3 mb-3">
          {attachLinks.map((link, i) => (
            <a
              key={i}
              href={`https://link.mygupta.co/${link?.attach_links}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 w-full bg-white border border-gray-200 rounded-2xl px-4 py-3.5 shadow-sm hover:shadow-md hover:border-green-200 transition-all group"
            >
              <div className="w-9 h-9 rounded-xl bg-green-500 flex items-center justify-center flex-shrink-0 group-hover:bg-green-600 transition-colors">
                <FaWhatsapp size={16} className="text-white" />
              </div>
              <span className="flex-1 text-sm font-semibold text-gray-700 text-center pr-9">{link?.attach_links}</span>
            </a>
          ))}
        </div>

        {/* Visit Website */}
        {businessSite && (
          <a
            href={businessSite.startsWith("http") ? businessSite : `https://${businessSite}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 w-full bg-white border border-gray-200 rounded-2xl px-4 py-3.5 mt-3 text-sm font-semibold text-gray-500 shadow-sm hover:shadow-md hover:text-gray-700 hover:border-gray-300 transition-all"
          >
            <FiExternalLink size={14} />
            Visit Website
          </a>
        )}

        {/* Footer */}
        <div className="text-center mt-10">
          <p className="text-xs text-gray-300 tracking-wide">Powered by Gupta</p>
        </div>
      </div>
    </div>
  );
}
